import { useEffect } from 'react';
import { useSelector, dispatch } from '../redux/store';
import { getEvents } from '../redux/slices/event';


export default function useEvents() {
  const { isLoading, events, error } = useSelector(state => state.events);

  useEffect(() =>{
    dispatch(getEvents())
  },[])
  return {loading:isLoading, events, error}
}
